import { jsx as e, Fragment as Y, jsxs as m } from "react/jsx-runtime";
import { useId as Ce, useState as Z, useMemo as g, useEffect as N, Fragment as Me } from "react";
import { useMultiStyleConfig as ze, useBreakpointValue as De, Flex as w, Checkbox as ee, Radio as je, Box as k, Table as ve, TableCaption as Pe, Stack as Fe, HStack as Le } from "@chakra-ui/react";
import { Switch as Ve } from "../../forms/Switch/Switch.mjs";
import { useReactTable as Oe, getCoreRowModel as Se, getExpandedRowModel as We, getSortedRowModel as Ae, flexRender as B } from "@tanstack/react-table";
import { AnimatePresence as Ge, LazyMotion as qe, domMax as Je, m as Ke } from "framer-motion";
import { DndProvider as Qe } from "react-dnd";
import { HTML5Backend as Ue } from "react-dnd-html5-backend";
import { Skeleton as Xe } from "../../feedback/Skeleton/Skeleton.mjs";
import { Typography as te } from "../Typography/Typography.mjs";
import { ColumnToggle as Ye } from "./ColumnToggle/ColumnToggle.mjs";
import { TableEmptyState as Ze } from "./TableEmptyState/TableEmptyState.mjs";
import { DraggableColumnHeader as Ne } from "./DraggableColumnHeader/DraggableColumnHeader.mjs";
import { Filter as we } from "./Filter/Filter.mjs";
import { TableContainer as et } from "./TableContainer.mjs";
import { TableExpand as tt } from "./TableExpand/TableExpand.mjs";
import { TableHeader as dt } from "./TableHeader/TableHeader.mjs";
import { TablePagination as at } from "./TablePagination/TablePagination.mjs";
import { Tbody as lt } from "./Tbody/Tbody.mjs";
import { Td as E } from "./Td/Td.mjs";
import { Thead as rt } from "./Thead/Thead.mjs";
import { Tr as I } from "./Tr/Tr.mjs";
import { Tfoot as st } from "./Tfoot.mjs";
import { ExpandRowIconButton as de } from "./ExpandRowIconButton.mjs";
import { RowSelection as ot } from "./RowSelection.mjs";
const it = "gravity-table", vt = ({
  actions: v,
  caption: P,
  columns: b,
  columnsControl: F = !1,
  columnOrder: L,
  columnVisibility: ae,
  data: V,
  debugAll: le,
  debugColumns: re,
  debugHeaders: se,
  debugRows: oe,
  debugTable: ie,
  dndContext: ne,
  emptyStateAddon: me,
  enableMultiRowSelection: x = !0,
  enableMultiSort: ce = !1,
  error: fe,
  expanded: O,
  getRowAccessibilityName: c,
  getRowCanExpand: pe,
  getSubRows: ge,
  id: S,
  isLoading: T = !1,
  onColumnOrderChange: R,
  onColumnVisibilityChange: he,
  onExpandedChange: y,
  onPageChange: H,
  onPageSizeChange: ue,
  onRowSelectionChange: o,
  onSearch: W,
  onSortingChange: _,
  pageCount: be,
  pageIndex: C = 0,
  pageSize: h = 10,
  renderEmptyState: A,
  renderFilterComponent: M,
  renderSubComponent: i,
  rowSelection: r,
  searchTerm: xe,
  selectedActions: Te,
  selectedLabel: G = (n) => `Selected items: ${n.length}`,
  sorting: Re,
  totalCount: q,
  ...$e
}) => {
  const n = `${it}-${S || Ce()}`, J = "select", $ = "expand", z = ze("Table"), [K, Q] = Z({}), ke = g(
    () => O || K,
    [O, K]
  ), Be = g(
    () => y || Q,
    [y, Q]
  ), [f, Ee] = Z(!1), l = De({ base: !0, md: !1 }, { fallback: "md" }), D = g(() => {
    let t = !1;
    return b.forEach((d) => {
      d.footer && (t = !0);
    }), t;
  }, [b]), Ie = g(
    () => ({
      pageIndex: C,
      pageSize: h
    }),
    [C, h]
  ), U = g(() => {
    let t = b;
    return (i && !l || l && !f && (t.length > 1 || i)) && (t = [
      ...t,
      {
        id: $,
        size: 16,
        enableSorting: !1,
        meta: {
          isReorderable: !1,
          isToggleable: !1
        },
        header: ({ table: d }) => /* @__PURE__ */ e(
          de,
          {
            onClick: d.getToggleAllRowsExpandedHandler(),
            "aria-label": "Expand all rows",
            isExpanded: d.getIsAllRowsExpanded()
          }
        ),
        cell: ({ row: d }) => /* @__PURE__ */ e(Y, { children: d.getCanExpand() || l ? /* @__PURE__ */ e(
          de,
          {
            onClick: d.getToggleExpandedHandler(),
            "aria-label": `Expand ${c ? `${c(d)} row` : `row ${d.id}`}`,
            isExpanded: d.getIsExpanded()
          }
        ) : i ? null : "" })
      }
    ]), o && (!l || f) && (t = [
      {
        id: J,
        size: 16,
        enableSorting: !1,
        meta: {
          isReorderable: !1,
          isToggleable: !1
        },
        header: ({ table: d }) => x && /* @__PURE__ */ e(w, { alignItems: "center", children: /* @__PURE__ */ e(
          ee,
          {
            "aria-label": "Select all rows",
            size: "sm",
            isChecked: d.getIsAllRowsSelected(),
            isIndeterminate: d.getIsSomeRowsSelected(),
            onChange: d.getToggleAllRowsSelectedHandler(),
            name: `${n}--select-all`
          }
        ) }),
        cell: ({ row: d }) => /* @__PURE__ */ e(w, { alignItems: "center", children: x ? /* @__PURE__ */ e(
          ee,
          {
            "aria-label": `Select ${c ? `${c(d)} row` : `row ${d.id}`}`,
            size: "sm",
            isChecked: d.getIsSelected(),
            isIndeterminate: d.getIsSomeSelected(),
            onChange: d.getToggleSelectedHandler(),
            name: `${n}--select-row-${d.id}`
          }
        ) : /* @__PURE__ */ e(
          je,
          {
            inputProps: {
              "aria-label": `Select ${c ? `${c(d)} row` : `row ${d.id}`}`
            },
            size: "sm",
            isChecked: d.getIsSelected(),
            onChange: d.getToggleSelectedHandler(),
            name: `${n}--select-row`
          }
        ) })
      },
      ...t
    ]), T && (t = t.map((d) => ({
      ...d,
      cell: () => /* @__PURE__ */ e(k, { py: 2, children: /* @__PURE__ */ e(Xe, { width: "100%", height: 3.5 }) })
    }))), t;
  }, [
    b,
    o,
    T,
    c,
    l,
    f
  ]);
  N(() => {
    if (R) {
      let t = L ?? [];
      (y || i || l) && (t = [...t, $]), o && (t = [J, ...t]), R(t);
    }
  }, []);
  const ye = g(
    () => T ? new Array(h).fill({}) : V ?? [],
    [T, V, h]
  ), s = Oe({
    data: ye,
    columns: U,
    defaultColumn: {
      minSize: 0,
      size: 0
    },
    state: {
      rowSelection: r,
      pagination: Ie,
      expanded: ke,
      sorting: Re,
      columnVisibility: ae,
      columnOrder: L
    },
    onColumnOrderChange: R,
    onSortingChange: _,
    onExpandedChange: Be,
    getSubRows: ge,
    manualPagination: !!H,
    onRowSelectionChange: o,
    getCoreRowModel: Se(),
    getExpandedRowModel: We(),
    getSortedRowModel: Ae(),
    debugAll: le,
    debugColumns: re,
    debugHeaders: se,
    debugRows: oe,
    debugTable: ie,
    manualSorting: !!_,
    enableMultiSort: ce,
    enableMultiRowSelection: x,
    getRowCanExpand: l ? () => !0 : pe,
    manualExpanding: !!i,
    onColumnVisibilityChange: he
  }), p = !!H && (q ?? 0) > 0, j = r || F || M || W || v, He = !!R, _e = !!_;
  return N(() => {
    o == null || o({});
  }, [f]), /* @__PURE__ */ e(Qe, { backend: Ue, context: ne ?? window, children: /* @__PURE__ */ m(k, { sx: z.container, children: [
    j && /* @__PURE__ */ e(k, { sx: z.headerContainer, children: /* @__PURE__ */ e(Ge, { children: /* @__PURE__ */ m(qe, { features: Je, children: [
      r && !!Object.keys(r).length && /* @__PURE__ */ e(
        ot,
        {
          selectedActions: Te,
          selectedLabel: G,
          rowSelection: r,
          onClick: () => s.resetRowSelection()
        }
      ),
      j && /* @__PURE__ */ m(Y, { children: [
        /* @__PURE__ */ e(
          Ke.div,
          {
            animate: {
              y: Object.keys(r ?? {}).length ? 20 : 0,
              opacity: Object.keys(r ?? {}).length ? 0 : 1,
              transition: {
                type: "spring",
                stiffness: 700,
                damping: 30
              }
            },
            children: /* @__PURE__ */ m(dt, { onSearch: W, children: [
              M && /* @__PURE__ */ e(we, { children: M }),
              F && !l && /* @__PURE__ */ e(Ye, { allColumns: s.getAllLeafColumns(), id: n }),
              v
            ] })
          }
        ),
        l && o && /* @__PURE__ */ e(
          Ve,
          {
            pb: 4,
            px: { base: 4, md: 0 },
            name: "select-rows",
            onChange: (t) => Ee(t.target.checked),
            isChecked: f,
            children: "Select Row(s)"
          }
        )
      ] })
    ] }) }) }),
    /* @__PURE__ */ e(et, { children: /* @__PURE__ */ m(ve, { minWidth: `${s.getTotalSize()}px`, id: n, ...$e, children: [
      P && /* @__PURE__ */ e(Pe, { children: P }),
      /* @__PURE__ */ e(rt, { children: s.getHeaderGroups().map((t) => /* @__PURE__ */ e(
        I,
        {
          sx: {
            ...!j && {
              "> th:first-of-type": { borderTopLeftRadius: "8px" },
              "> th:last-child": { borderTopRightRadius: "8px" },
              "> th": { borderTop: "none" }
            }
          },
          children: t.headers.map((d, a) => {
            if (!l || l && (a === 0 || f && a === 1 || d.id === $))
              return /* @__PURE__ */ e(
                Ne,
                {
                  canReorderColumns: He,
                  header: d,
                  table: s,
                  canSortColumns: _e,
                  enableMultiRowSelection: x
                },
                d.id
              );
          })
        },
        t.id
      )) }),
      /* @__PURE__ */ e(lt, { children: s.getRowModel().rows.length === 0 ? A ? /* @__PURE__ */ e(I, { children: /* @__PURE__ */ e(
        E,
        {
          colSpan: s.getHeaderGroups()[0].headers.length,
          ...p ? { borderBottomRadius: "none" } : { borderBottomRadius: "lg" },
          children: A
        }
      ) }) : /* @__PURE__ */ e(
        Ze,
        {
          colSpan: U.length,
          searchTerm: xe,
          error: fe,
          addOn: me,
          showPaginationFooter: p,
          isMobile: l
        }
      ) : s.getRowModel().rows.map((t, d) => /* @__PURE__ */ m(Me, { children: [
        /* @__PURE__ */ e(
          I,
          {
            _last: p || D ? {
              "> td": {
                _first: { borderBottomLeftRadius: "none" },
                _last: { borderBottomRightRadius: "none" }
              }
            } : {
              "> td": {
                borderBottom: "none",
                _first: { borderBottomLeftRadius: "lg" },
                _last: { borderBottomRightRadius: "lg" }
              }
            },
            "data-selected": r == null ? void 0 : r[d],
            children: l ? t.getVisibleCells().map((a, u) => {
              var X;
              if (u === 0 || f && u === 1 || a.id.match(/^\d+_expand$/))
                return /* @__PURE__ */ e(
                  E,
                  {
                    width: a.column.getSize() !== 0 ? `${a.column.getSize()}px` : void 0,
                    isNumeric: (X = a.column.columnDef.meta) == null ? void 0 : X.isNumeric,
                    ...!t.getIsExpanded() && { borderBottomWidth: "1px" },
                    children: B(a.column.columnDef.cell, a.getContext())
                  },
                  a.id
                );
            }) : t.getVisibleCells().map((a) => {
              var u;
              return /* @__PURE__ */ e(
                E,
                {
                  width: a.column.getSize() !== 0 ? `${a.column.getSize()}px` : void 0,
                  isNumeric: (u = a.column.columnDef.meta) == null ? void 0 : u.isNumeric,
                  ...!t.getIsExpanded() && { borderBottomWidth: "1px" },
                  children: B(a.column.columnDef.cell, a.getContext())
                },
                a.id
              );
            })
          }
        ),
        t.getIsExpanded() && (l || i) && /* @__PURE__ */ e(
          I,
          {
            "data-table-row-expander": !0,
            _last: p || D ? {
              "> td": {
                _first: { borderBottomLeftRadius: "none" },
                _last: { borderBottomRightRadius: "none" }
              }
            } : {
              "> td": {
                borderBottom: "none",
                _first: { borderBottomLeftRadius: "lg" },
                _last: { borderBottomRightRadius: "lg" }
              }
            },
            children: /* @__PURE__ */ m(E, { colSpan: t.getVisibleCells().length, children: [
              l && /* @__PURE__ */ e(Fe, { spacing: "0", children: t.getAllCells().filter((a) => !a.id.match(/^\d+_(select|expand)$/)).map((a) => /* @__PURE__ */ m(
                Le,
                {
                  justifyContent: "space-between",
                  px: 4,
                  py: 3,
                  spacing: 4,
                  children: [
                    /* @__PURE__ */ e(te, { variant: "bodyBoldSmall", children: B(
                      a.column.columnDef.header,
                      // Should get header context, but this still seems to work
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      a.getContext()
                    ) }),
                    /* @__PURE__ */ e(te, { variant: "bodySmall", children: B(
                      a.column.columnDef.cell,
                      a.getContext()
                    ) })
                  ]
                },
                `${t.id}-${a.id}`
              )) }),
              i && /* @__PURE__ */ e(tt, { children: i({ row: t }) })
            ] })
          }
        )
      ] }, t.id)) }),
      D && /* @__PURE__ */ e(
        st,
        {
          expandRowId: $,
          isMobile: l,
          showPaginationFooter: p,
          table: s
        }
      )
    ] }) }),
    p && /* @__PURE__ */ e(
      at,
      {
        id: n,
        pageSize: h,
        totalCount: q ?? 0,
        onPageSizeChange: ue,
        pageCount: be ?? 0,
        currentPage: C,
        onPageClick: H
      }
    ),
    /* @__PURE__ */ e(k, { role: "status", "aria-live": "polite", sx: z.status, children: r && Object.keys(r).length ? `${G(Object.keys(r))}` : "No rows selected" })
  ] }) });
};
export {
  vt as Table,
  it as tableIdPrefix
};
